import React, { useState } from 'react';
import { useRef, useEffect, forwardRef, useImperativeHandle } from 'react'
import { ReactSVG } from "react-svg";
import i18n from "../../i18n/i18n.js";
import TypedLink from '../../components/TypedLink/TypedLink';

import './ProductListItem.css';

const ProductListItem = forwardRef((props, ref) => {

  const [product, setProduct] = useState((props.product) ? props.product : {});
  const [show_fav_icon,setFavIcon] = useState((props.show_fav_icon) ? props.show_fav_icon : false);
  const [index,setIndex] = useState((props.index) ? props.index : 0);

  const on_fav_click = props.on_fav_click ? props.on_fav_click : () => {};

  const handle_product_click = (e, product) => {
    if(typeof props.parentFunction==='function'){
        props.parentFunction(e, product);
    }
  };
  
  useImperativeHandle(ref, () => ({
    // Expose parent function to parent component
    callParentFunction: handle_product_click,
  }));


  function handle_fav_click(event) {

    event.preventDefault();
 
    product.fav = product.fav ? 0 : 1;

    setProduct(product);
    on_fav_click(product);
  }

  function render_image(product)
  {
    if(product?.product_image[0]?.thumb_list_new_?.filename)
    {
      return <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0].thumb_list_new_.filename}/>
    }
  }

  return ( 
    <div key={product.id} data-index={product.index} className={`product_list_item ${(product.sale) ? ' sale' : ''}  ${parseInt(product.newness)>0 ? ' newness' : ''}`}> 

      {parseInt(product.sale)>0 ? <div className='sale badge'>{i18n.t('productItmeSaleBadge')}</div> : ''}
      {(parseInt(product.newness)>0 && parseInt(product.sale)==0)  ? <div className='newness badge'>{i18n.t('productItemNewBadge')}</div> : ''}

      <div className="product_image">
        <TypedLink onClick={(e) => handle_product_click(e, product)} link={{type: 'product', url: product.url}}>
          {show_fav_icon ? <ReactSVG className="fav" onClick={(e) => handle_fav_click(e)} src={`assets/images/fav_${product.fav ? 'on' : 'off'}_black.svg`} /> : ''}
          {render_image(product)}
        </TypedLink>
      </div> 

      <div className="name"><b>{product.product}</b></div>

      <div className="price">
        <b className={`${!!product.sale ? 'stroked' : ''}`}>{(product.sale!==0) ?  product.price_original_gross : product.price_gross}</b>
        {!!product.sale ? <b className="sale">{product.price_gross}</b> : ''}
      </div>

    </div>
  );
});
/*
class ProductListItem extends React.Component {

  max_quantity = 100;

  constructor(props) {
    super(props);

    this.state = {
      product: props.product ? props.product : {},
      show_fav_icon: props.show_fav_icon ? props.show_fav_icon : false,
    };

    this.parent_obj = props.parent_obj ? props.parent_obj : null;
    this.on_fav_click = props.on_fav_click ? props.on_fav_click : () => {};
    this.on_product_click = props.on_product_click ? props.on_product_click : () => {};

  }

  handle_product_click(event) {

    if(this.parent_obj && this.parent_obj.set_list_back_cache!==undefined)
    {
      this.parent_obj.set_list_back_cache();
    }

    this.on_product_click(event, this.state.product);
  }

  handle_fav_click(event) {

    event.preventDefault();

    const product = this.state.product;

    product.fav = product.fav ? 0 : 1;

    this.setState({product}, () => {
      this.on_fav_click(this.state.product);
    });
  }

  render_image(product)
  {
    if((product.product_image && product.product_image[0].thumb_list_new_ && product.product_image[0].thumb_list_new_.filename) )
    {
      return <img src={process.env.REACT_APP_ORIGINAL_SHOP_URL+'/'+product.product_image[0].thumb_list_new_.filename}/>
    }
  }

  render() {

    const { product, show_fav_icon } = this.state;

    if (!!product.id)
    {
      return ( 

        <div key={product.id} className={`product_list_item ${(product.sale) ? ' sale' : ''}  ${(product.newness) ? ' newness' : ''}`}> 

          {product.sale ? <div className='sale badge'>{i18n.t('productItmeSaleBadge')}</div> : ''}
          {product.newness ? <div className='newness badge'>{i18n.t('productItemNewBadge')}</div> : ''}

          <div className="product_image">
            <TypedLink onClick={(e) => this.handle_product_click(e)} link={{type: 'product', url: product.url}}>
              {show_fav_icon ? <ReactSVG className="fav" onClick={(e) => this.handle_fav_click(e)} src={`assets/images/fav_${product.fav ? 'on' : 'off'}_black.svg`} /> : ''}
              {this.render_image(product)}
            </TypedLink>
          </div> 

          <div className="name"><b>{product.product}</b></div>

          <div className="price">
            <b className={`${!!product.sale ? 'stroked' : ''}`}>{(product.sale!==0) ?  product.price_original_gross : product.price_gross}</b>
            {!!product.sale ? <b className="sale">{product.price_gross}</b> : ''}
          </div>

        </div>
      );
    }
    else {
      return '';
    }
  }
};
*/

export default ProductListItem;